import { FC, useEffect } from "react";
import { useMantineColorScheme } from "@mantine/core";
import IconSun from "/svg/sun.svg";
import IconMoon from "/svg/moon.svg";
import styles from "./ThemeToggle.module.scss";
import { DefaultIcon } from "@shared/ui";

export const ThemeToggle: FC = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";
  const root = document.documentElement;
  const stylesTheme = getComputedStyle(root);
  const mainBgColor = stylesTheme.getPropertyValue("--color-bg").trim();

  useEffect(() => {
    window.Telegram.WebApp.setBackgroundColor(mainBgColor);
    window.Telegram.WebApp.setHeaderColor(mainBgColor);
    window.Telegram.WebApp.setBottomBarColor(mainBgColor);
    // window.Telegram.WebApp.setBottomBarBackgroundColor(mainBgColor);
  }, [isDark, toggleColorScheme]);

  const handleToggle = () => {
    toggleColorScheme();
  };

  return (
    <button
      className={styles.toggleButton}
      onClick={handleToggle}
      aria-label="Toggle color scheme"
    >
      {isDark ? (
        <DefaultIcon src={IconSun} className={styles.icon} />
      ) : (
        <DefaultIcon src={IconMoon} className={styles.icon} />
      )}
    </button>
  );
};
